import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { FormsModule } from '@angular/forms';
import { Select2Module } from 'ng2-select2';
import { TextMaskModule } from 'angular2-text-mask';
import { ReactiveFormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { AlertModule } from 'ngx-bootstrap/alert';
import { NgSelect2Module } from 'ng-select2';
import { TelaPrincipalComponent } from './tela-principal/tela-principal.component';
import { TelaAjudaComponent } from './tela-ajuda/tela-ajuda.component';
import { TelaSuporteComponent } from './tela-suporte/tela-suporte.component';
import { TelaNoticiasComponent } from './tela-noticias/tela-noticias.component';
import { TelaBoletoComponent } from './tela-boleto/tela-boleto.component';
import { PortalService } from './portal.service';
import { AngularBaseUiModule } from 'app/angular-base-ui/angular-base-ui.module';


@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    CollapseModule,
    TooltipModule.forRoot(),
    FormsModule,
    Select2Module,
    TextMaskModule,
    ReactiveFormsModule,
    ModalModule.forRoot(),
    BsDropdownModule.forRoot(),
    AlertModule.forRoot(),
    NgSelect2Module,
    AngularBaseUiModule
  ],
  declarations: [
    TelaPrincipalComponent,
    TelaAjudaComponent,
    TelaSuporteComponent,
    TelaNoticiasComponent,
    TelaBoletoComponent,
  ],
  exports: [
    TelaPrincipalComponent  
  ],
  providers: [
    PortalService
  ]
})
export class PortalModule { }



// WEBPACK FOOTER //
// C:/Disco D/Projetos/central-cliente/src/app/area-cliente/portal/portal.module.ts